import React from "react";
import Index from "../../Index";

export default function BlueFillButton(props) {
  return (
    <>
      <Index.Box className="blue-fill-btn-main">
        <Index.Button
          className={props.className}
          type={props.type}
          onClick={props.onClick}
          component={props.component}
          disableRipple
          {...props}
        >
          {props.btnLabel}
        </Index.Button>
      </Index.Box>

      {/* use this button like below demo */}
      {/* <PagesIndex.BlueFillButton btnLabel="View Button" className="blue-fill-btn"/> */}
    </>
  );
}
